import { gql } from '@apollo/client';

export const getFacOfPoliciesQuery = gql`
  query getFacOfPoliciesOfReinsurer($ReinsurerID: String!) {
    Accounting {
      queries {
        GetFacOfPoliciesOfReinsurer(ReinsurerID: $ReinsurerID) {
          facultative_Id
          facultative_FacultativeID
          facultative_SlipReferenceNumber
          policy_PolicyNumber
          facultative_PaymentDueDate
          facultative_TotalCededPremium
          facultative_TotalCommission
          facBill_AmountDue
          facBill_AmountPaid
          facBill_OutstandingBalance
          facBill_Currency {
            Code
            Symbol
          }
        }
      }
    }
  }
`;
